import { useBooleanState } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { StepControls } from 'features/organization_settings/shared/step';
import { isTestSamlSettingsLoadingSelector, testSamlSettingsSelector, testSamlSessionSettingsSelector } from '../selectors';
import { setTestSamlSettings } from '../slice';
import { applyTestSamlSettings } from '../thunks';
import { ConfirmExitModal } from './confirm_exit_modal';
import { STEPS } from './constants';
const enforcementSubtitleCss = "eqbw1if";
const EnforcementSubtitle = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'p';
  return <Component ref={ref} {...restProps} className={classNames(enforcementSubtitleCss, props.className)} />;
});
export const ApplyTestSettings = ({
  onClose
}) => {
  const dispatch = useDispatch();
  const [isOpen, openModal, closeModal] = useBooleanState(false);
  const testSamlSettings = useSelector(testSamlSettingsSelector);
  const sessionSettings = useSelector(testSamlSessionSettingsSelector);
  const isLoading = useSelector(isTestSamlSettingsLoadingSelector);
  const onBackClick = () => dispatch(setTestSamlSettings({
    step: STEPS.CONNECTION
  }));
  const handleCancel = () => openModal();
  const handleClickApply = () => dispatch(applyTestSamlSettings({
    testSamlSettings,
    sessionSettings
  }));
  return <>
      <EnforcementSubtitle>
        {I18n.t('publisher.organization_settings.test_saml_settings.apply_test_settings.subtitle')}
      </EnforcementSubtitle>
      <ContextualBanner spacingBottom={20}>
        {I18n.t('publisher.organization_settings.test_saml_settings.apply_test_settings.warning')}
      </ContextualBanner>
      <StepControls>
        <Button decoration="ghost" onClick={onBackClick}>{I18n.t('publisher.action.go_back')}</Button>
        <Button decoration="secondary-outline" onClick={handleCancel}>{I18n.t('publisher.action.cancel')}</Button>
        {isOpen && <ConfirmExitModal isOpen={isOpen} onClose={closeModal} onConfirm={onClose} title={I18n.t('publisher.organization_settings.test_saml_settings.confirm_exit_modal')} />}
        <Button decoration="danger" onClick={handleClickApply} loading={isLoading}>
          {I18n.t('publisher.organization_settings.test_saml_settings.apply_test_settings.apply')}
        </Button>
      </StepControls>
    </>;
};

require("./apply_test_settings.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./apply_test_settings.js");